module.exports = __webpack_public_path__ + "img/IMG_2248_L_Black_MockedUp.d68e6220.jpg";